import {Box, createTheme, CssBaseline, GlobalStyles, ThemeProvider} from "@mui/material";
import theme from "../theme";
import rtlPlugin from 'stylis-plugin-rtl';
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import {prefixer} from 'stylis';
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import {ToastyContainer} from "../theme/components/ToastyContainer";
import {useEffect, useMemo} from "react";
import useThemeStore from "../store/theme";
import {useLocation, useNavigate} from "react-router-dom";
import DownloadPopup from "../components/common/downloadPopup";
import {useUser} from "../lib/hooks";

const MainLayout = ({children}) => {

    const mode = useThemeStore((state) => state.mode);
    // Update the theme only if the mode changes
    const theTheme = useMemo(() => createTheme(theme(mode)), [mode]);

    // Create rtl cache
    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    // const user = useUser();
    // const navigate = useNavigate();

    const location = useLocation();
    useEffect(()=> {
        // if (user && !location.pathname.includes('/share')) navigate('/drive');
        if (location.hash) {
            let elem = document.getElementById(location.hash.slice(1))
            if (elem) {
                elem.scrollIntoView({behavior: "smooth"})
            }
        } else {
            window.scrollTo({top:0,left:0, behavior: "smooth"})
        }
    }, [location,])

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theTheme}>
                <CssBaseline/>
                <GlobalStyles styles={`@import url("/assets/css/main.css");`}/>
                <Header/>
                <Box component="main">
                    {children}
                </Box>
                <Footer/>
                <ToastyContainer/>
                <DownloadPopup/>
            </ThemeProvider>
        </CacheProvider>
    );
}
export default MainLayout;
